<template>
  <div class="max-w-main bg-vmain">
    <div class=" pt-3">
        <img @click="$router.push('/')" class="ml-8 h-8 cursor-pointer" src="../../assets/logo_web.png" >
    </div>
    <div class=" p-3">
        <div class="font-bold text-2xl text-center font-bold-vmain p-4">
            Blog
        </div>
        <slide></slide>
        <div class="">
            <div class="ft-16 fw-700 category_blog_news">
                Mới nhất
            </div>
            <div class="mgt-10 category_list_parent">
                <span class="categoy_lists" v-for="(i,index) in category"
                        :key="i.id">
                    <span v-if="c_active == index" class="active-btn category-btn main-center pd-5 mgt-10 categoy_list_active">
                        {{ i.name }}
                    </span>
                    <span @click="changeCategory(index,i.id)" v-else class="category-btn main-center content-box-app pd-5 mgt-10 categoy_list cursor-pointer">
                        {{ i.name }}
                    </span>
                </span>
            </div>
            
            <div v-for="i in data_list" :key="i.id" class="mgt-10 mb-5">
                <div @click="viewDetail(i.id,i.slug)" class="blogs_list_img cursor-pointer">
                    <img  height="176" width="100%" style="border-radius: 10px;" :src="i.image" fluid alt="Responsive image">
                </div>
                <div @click="viewDetail(i.id,i.slug)" class="fw-700 mgt-10 ft-16 blogs_list_title cursor-pointer">
                    {{ i.name }}
                </div>
                <div style="color: grey;" class="mgt-10">
                    <div style="color: grey;" class="mgt-10">
                        
                        <div class="grid grid-cols-3 gap-4 slide_content">
                            <div class="col-span-2 ... slider_category">{{ i.category_name }}</div>
                            <div class="... time_format">
                                {{ i.updated_time | toDMY }}
                            </div>
                        </div>
                    </div>
                    <!-- <b-row>
                        <b-col>
                            {{ i.category_name }}
                        </b-col>
                        <b-col style="text-align: right;">
                            {{ i.updated_time | toDMY }}
                        </b-col>
                    </b-row> -->
                </div>
            </div>

            <div>
                 <b-pagination align="center" @change="changePage" :per-page="page_size" v-model="page"  :total-rows="total"></b-pagination>
            </div>

            <footer-mo></footer-mo>
            <!-- <b-container class="content-box-app">
                <footer-mo></footer-mo>
            </b-container> -->
        </div>
    </div>
  </div>
</template>

<script>
import FooterMo from '../footer/index.vue'
import Slide from './components/slide.vue'
import { getHotBlog,getListBlog,getCategoryBlog } from '@/api/otp'

import { getToken } from '@/utils/auth'
// import TopLogo from '../../components/TopLogo.vue';
import { Glide, GlideSlide } from 'vue-glide-js'


export default {
    components: { Slide,FooterMo },
    data(){
        return{
            total: 100,
            currentPage: 1,
            category: [
                
            ],
            news: [
            ],
            data_hot: [
            ],
            data_list: [],
            c_active: 0,
            page_size: 2,
            page: 1,
            category_id: undefined,
        }
    },
    methods: {
        viewDetail(id,slug){
            //this.$router.push('/blog/chi-tiet/' +id +'/'+slug)
            this.$router.push('/'+slug+'.html')
        },
        fetchHotBlog(){
            getHotBlog({}).then(res => {
                this.data_hot = res.data
            })
        },
        changePage(page){
            console.log(page)
            this.page = page
            this.fetchListBlog()
        },
        changeCategory(index,id){
            this.c_active = index
            this.category_id = id
            this.fetchListBlog()
        },
        fetchListBlog(){
            getListBlog({
                page: parseInt(this.page),
                page_size: this.page_size,
                category_id: this.category_id
            }).then(res=> {
                this.data_list = res.data
                this.total = res.total_page
            })
        },
        fetchCategoryBlog(){
            getCategoryBlog({}).then(res => {
                let arr = [{
                    id: undefined,
                    name: 'Tất cả',
                }];
                this.category = res.data
                this.category = arr.concat(this.category)
            })
        }
    },
    created(){
        this.fetchCategoryBlog()
        //this.fetchHotBlog()
        this.fetchListBlog()
    }
}
</script>

<style>
.logo_web {
    padding-top: 2%;
    margin-bottom: 35px;
}
.logo_web img {
    margin-left: 15px;
}
.mgt-30 {
    padding-left: 15px;
}
.mgt-30 .title-mid {
    font-style: normal;
    font-weight: 700;
    font-size: 22px;
    line-height: 24px;
    text-align: center;
    color: #34404B;
}
.categoy_lists {
    margin-right: 20px;
}
.categoy_lists .categoy_list {
    height: 32px;margin-top: 5px;
    border: 1px solid white;
    padding: 8px;
    background: #FFFFFF;
    border-radius: 8px;
}
.categoy_lists .categoy_list_active {
    height: 32px;margin-top: 5px;
    padding: 8px;
    border-radius: 8px;
    background: #FEF0ED;
    border: 1px solid #F1674A;
    color: #F1674A;
}
.page-link {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    color: black;
    margin-left: 5px;
    background-color: #fff;
    border: 1px solid #dee2e6;
    border-radius: 8px !important;
    min-width: 33.8px;
}
.category_blog_news {
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 133%;
    letter-spacing: -0.03em;
    color: #34404B;
    margin-top: 25px;
    margin-bottom: 10px;
}
.category_list_parent {
    overflow: auto;white-space: nowrap;padding-top: 10px;margin-bottom:20px;
    overflow-y: hidden;
	overflow-x: auto;
	-webkit-overflow-scrolling: touch !important;
    height: 60px !important;
    scroll-behavior: smooth !important;
}
::-webkit-scrollbar {
  width: 2px;
}

.page-item.active .page-link {
    z-index: 3;
    color: #F1674A;
    background-color: #FEF0ED;
    border-color: #F1674A;
}
.blogs_list {
    padding-right: 15px;
    margin-bottom: 40px;
}
.blogs_list .blogs_list_img {
    margin-bottom: 10px;
}
.blogs_list .blogs_list_title {
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: -0.03em;
    color: #34404B;
}
.footer_address {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 142%;
    letter-spacing: -0.03em;
    color: #717981;
    margin-top: 30px;
    margin-bottom: 20px;
}
.justify-content-center .page-item {
    margin-right: 10px;
}
</style>